/**
 * Post-login redirect targets (`?next=`, `redirect_path`) are attacker-influenced strings (magic-link
 * emails, OIDC start links). Only a same-origin absolute path is accepted: it must start with a single
 * `/`, so `//evil`, `/\evil`, `http://…` and `javascript:` all fall back to `/` (REVIEW finding 24).
 */
export const SAFE_NEXT_RE = /^\/(?![/\\])[^\s\\]*$/;

export function safeNext(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  if (!SAFE_NEXT_RE.test(raw)) return fallback;
  // a path that decodes to a protocol-relative URL is just as bad
  try {
    if (/^\/[/\\]/.test(decodeURIComponent(raw))) return fallback;
  } catch {
    return fallback;
  }
  return raw;
}
